import { useState } from 'react';

import { VIDEO_CAMERA_ORDER, VideoStreamType, detectStreamCount } from '../../../../../../utils/ImageDimensions';

export interface UseStreamNavigationResult {
    currentImageIndex: number;
    availableStreams: VideoStreamType[];
    setCurrentImageIndex: (index: number | ((prev: number) => number)) => void;
    setAvailableStreams: (streams: VideoStreamType[]) => void;
    detectStreamsFromImage: (imageSrc: string) => void;
    resetNavigation: () => void;
    isLastImage: boolean;
    currentStream: VideoStreamType | undefined;
}

export const useStreamNavigation = (): UseStreamNavigationResult => {
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
    const [availableStreams, setAvailableStreams] = useState<VideoStreamType[]>([]);

    const detectStreamsFromImage = (imageSrc: string) => {
        const img = new window.Image();
        img.onload = () => {
            const streamCount = detectStreamCount(img.width, img.height);
            const streams = VIDEO_CAMERA_ORDER.slice(0, streamCount);
            setAvailableStreams(streams);
            setCurrentImageIndex(0);
        };
        img.onerror = () => {
            // Default to at least 2 streams (InCabin and FrontFacing) when image fails to load
            const defaultStreams = VIDEO_CAMERA_ORDER.slice(0, 2);
            setAvailableStreams(defaultStreams);
            setCurrentImageIndex(0);
        };
        img.src = imageSrc;
    };

    const resetNavigation = () => {
        setCurrentImageIndex(0);
        setAvailableStreams([]);
    };

    const isLastImage = currentImageIndex >= availableStreams.length - 1;
    const currentStream = availableStreams[currentImageIndex];

    return {
        currentImageIndex,
        availableStreams,
        setCurrentImageIndex,
        setAvailableStreams,
        detectStreamsFromImage,
        resetNavigation,
        isLastImage,
        currentStream,
    };
};
